"use client";
import { Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import { SimpleList } from "@/components/list";

type ContentPointProps = {
  text: string;
  points: string[];
};

const ContentPoints = ({ text, points }: ContentPointProps) => {
  const textVariant = useTextVariant();
  return (
    <Stack gap={4}>
      <Text variant={textVariant} color="text.100">
        {text}
      </Text>
      <SimpleList points={points} />
    </Stack>
  );
};

export const FAQS = [
  {
    title: "What are the main advantages of using a Hosted PBX service?",
    content:
      "Hosted PBX services offer simplified deployment, scalability, advanced features, and reduced operational costs, enabling businesses to enhance their communication systems without the complexities of managing on-premises hardware.",
  },
  {
    title: "Can I integrate Hosted PBX with my existing CRM system?",
    content:
      "Yes, Hosted PBX solutions often support integration with various CRM systems, allowing for improved customer interaction and streamlined workflows.",
  },
  {
    title: "How does Hosted PBX support remote work?",
    content:
      "Hosted PBX enables employees to access the phone system from any location with internet connectivity, facilitating seamless communication for remote and mobile teams.",
  },
  {
    title: "What kind of support is available for Hosted PBX services?",
    content:
      "Providers like Onemind offer expert support for deployment, configuration, performance optimization, and ongoing maintenance, ensuring your communication system operates efficiently.",
  },
  {
    title: "How secure is a Hosted PBX system?",
    content:
      "Hosted PBX systems employ data encryption, secure data centers, and regular security updates to protect sensitive communication data from unauthorized access.",
  },
  {
    title: "Can I customize the features of my Hosted PBX system?",
    content:
      "Yes, Hosted PBX solutions are highly customizable, allowing businesses to select and configure features that align with their specific communication requirements.",
  },
  {
    title: "How does Hosted PBX handle call quality?",
    content:
      "Call quality in Hosted PBX systems is maintained through high-performance infrastructure, sufficient bandwidth, and Quality of Service (QoS) protocols to prioritize voice traffic.",
  },
  {
    title: "Is Hosted PBX suitable for small businesses?",
    content:
      "Absolutely. Hosted PBX offers cost-effective solutions with enterprise-level features, making it an excellent choice for small businesses looking to enhance their communication capabilities without significant investment.",
  },
  {
    title: "How secure is a Hosted PBX system against cyber threats?",
    content: (
      <ContentPoints
        text="Hosted PBX providers implement enterprise-grade security measures, including:"
        points={[
          "End-to-End Encryption – Protects voice data during transmission.",
          "Multi-Factor Authentication (MFA) – Adds an extra layer of security for system access.",
        ]}
      />
    ),
  },
  {
    title:
      "Can Hosted PBX integrate with Microsoft Teams, Zoom, and other collaboration tools?",
    content: (
      <ContentPoints
        text="Yes! Many Hosted PBX providers offer direct integrations with collaboration platforms such as:"
        points={[
          "Microsoft Teams – Unified communications with VoIP calling, video, and messaging.",
          " Zoom Phone – Cloud-based business phone system integration.",
          "Slack & WhatsApp – Enhanced messaging and VoIP functionalities.",
          "CRM Systems – Seamless integration with Salesforce, HubSpot, Zoho, and more.",
        ]}
      />
    ),
  },
  {
    title: "How do I get started with Hosted PBX on Onemind ? ",
    content:
      "Getting started is easy! Onemind  offers a free consultation to assess your business communication needs and tailor a Hosted PBX solution that fits your requirements. ",
  },
];
